const SingleLineSkeleton = () => {
  return (
    <div role="status" class="max-w-sm animate-pulse">
      <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
      <span class="sr-only">Loading...</span>
    </div>
  );
};
export default SingleLineSkeleton;
